var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExpMarkerImageSrcSelect(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 51,
    viewBox: "0 0 46 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_59_2849)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43 20C43 29.0601 36.9757 36.7131 28.7143 39.1718C25.8571 40 23 45 23 45C23 45 20.1429 40 17.2857 39.1718C9.02432 36.7131 3 29.0601 3 20C3 8.9543 11.9543 0 23 0C34.0457 0 43 8.9543 43 20Z",
    fill: "#FFB800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 44.0447C22.977 44.0088 22.9531 43.9717 22.9284 43.9337C22.6099 43.4428 22.1543 42.7784 21.6063 42.0861C21.0594 41.3952 20.4134 40.6675 19.713 40.0554C19.0179 39.448 18.2399 38.9282 17.4267 38.6921C9.37234 36.2942 3.5 28.8322 3.5 20C3.5 9.23045 12.2304 0.5 23 0.5C33.7696 0.5 42.5 9.23045 42.5 20C42.5 28.8323 36.6276 36.2942 28.5732 38.6921C27.7601 38.9282 26.982 39.448 26.2871 40.0554C25.5866 40.6675 24.9406 41.3952 24.3937 42.0861C23.8457 42.7784 23.3901 43.4428 23.0716 43.9337C23.0469 43.9717 23.023 44.0088 23 44.0447Z",
    stroke: "#FFB800"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1459 28.0208L13.1459 19.3125H16.8125V13.8125H29.1875V19.3125H32.8542V28.0208H25.0625V25.5C25.0625 24.3609 24.1391 23.4375 23 23.4375C21.861 23.4375 20.9375 24.3609 20.9375 25.5V28.0208H13.1459ZM14.5209 26.6458H19.5625V25.5C19.5625 23.6015 21.1016 22.0625 23 22.0625C24.8985 22.0625 26.4375 23.6015 26.4375 25.5V26.6458H31.4792V20.6875H27.8125L27.8125 15.1875L18.1875 15.1875V20.6875H14.5209V26.6458Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.8542 17.25L32.8542 19.3125L31.4792 19.3125V17.25H32.8542Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5209 17.25L14.5209 19.3125H13.1459L13.1459 17.25H14.5209Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.8542 17.25V20H20.4792V17.25H21.8542Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.8542 11.75V13.8125H20.4792V11.75L21.8542 11.75Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.5209 17.25V20H24.1459V17.25H25.5209Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.5209 11.75V13.8125H24.1459V11.75L25.5209 11.75Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.1875 11.75V13.8125L27.8125 13.8125V11.75L29.1875 11.75Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1875 11.75V13.8125L16.8125 13.8125L16.8125 11.75L18.1875 11.75Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_59_2849",
    x: 0,
    y: 0,
    width: 46,
    height: 51,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_59_2849"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_59_2849",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpMarkerImageSrcSelect);
export default __webpack_public_path__ + "static/media/expMarkerImageSrc_select.1abdd3c8a9a38d53005eae05ef7e3bb4.svg";
export { ForwardRef as ReactComponent };